module.exports = __webpack_public_path__ + "static/media/plus.a8aca03a.svg";